
import React, { useEffect, useState } from "react";
import { CommonHeader } from "../../../components/commons";
import AllPerformanceEvaluation from "../../../components/MySpace/PEFormModule/AllPerformanceEvaluation";
import MyPerformanceEvaluationList from "../../../components/MySpace/PEFormModule/MyPerformanceEvaluationList";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";


type TabsType = {
  name: string;
  label: string;
  display: boolean | undefined;
};
const tabs: TabsType[] = [
  {
    name: "All PE Forms",
    label: "allPE",
    display: false,
  },
  {
    name: "My PE Forms",
    label: "myPe",
    display: false,
  },
];
type AppProps = {
  history?: any;
};
const PerformanceEvaluationList = ({ history }: AppProps) => {
  const redirectActiveTab = history?.location?.state?.activeTab;

  const [activeComponent, setActiveComponent] = useState<any>();
  const [finalTab, setFinalTab] = useState(tabs);

 const [isMyPerformanceEvaluationPresent , setIsMyPerformanceEvaluationPresent] = useMenuCheck("")
 const [isManagerPerformanceEvaluationPresent , setIsManagerPerformanceEvaluationPresent] = useMenuCheck("")

  const [activeTab, setActiveTab] = useState( redirectActiveTab?redirectActiveTab:tabs[0]?.label);

useEffect(()=>{
  setIsMyPerformanceEvaluationPresent("My Performance Evaluation Form List", "menu")
  setIsManagerPerformanceEvaluationPresent("Manager's View Performance Evaluation Form List","menu")
  
},[])
  useEffect(() => {
    if (redirectActiveTab==="myPe") {
      setActiveTab("myPe");
    }
    else{
      setActiveTab("allPE")
    }
  }, [redirectActiveTab]);

  useEffect(()=>{
    if(redirectActiveTab){
      setActiveTab(redirectActiveTab)
    }
      },[redirectActiveTab])

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };
  const renderTabs = () => {
    const filterTab =
    isMyPerformanceEvaluationPresent && isManagerPerformanceEvaluationPresent
      ? tabs
      : isMyPerformanceEvaluationPresent
      ? [tabs[1]]
      : [tabs[0]];
    const finalTabs = filterTab?.map((tab: TabsType) => {
      return (
        <div
          key={tab?.label}
          className={tab.display ? "tab-style mr-4 pointer" : "pointer"}
          onClick={() => {
            handleTabChange(tab?.label);
          }}
        >
          <div
            style={{
              padding: "12px 16px 12px 5px",
              color: activeTab === tab?.label ? "#dd4433" : "",
              fontSize: "16px",
            }}
            className={`tab-header ${activeTab === tab?.label ? "active" : ""}`}
          >
            {tab?.name}
          </div>
          <div
            className={`${
              activeTab === tab?.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });
    return finalTabs;
  };

  const activeTabRender = () => {
    switch (activeTab) {
      case "allPE":
        return (
           isManagerPerformanceEvaluationPresent && <AllPerformanceEvaluation
            activeTab={activeTab}
            history={history}
          
          />
        );
      case "myPe":
        return (
        isMyPerformanceEvaluationPresent &&  <MyPerformanceEvaluationList
            activeTab={activeTab}
            history={history}

          />
        );

      default:
        return (
          isManagerPerformanceEvaluationPresent&&  <AllPerformanceEvaluation
            activeTab={activeTab}
            history={history}

          />
        );
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader title="Performance Evaluation List" />
        </div>
      </div>
      <div className="col-md-12 mt-4">
        <div
          style={{
            background: "#d8dee4",
            borderRadius: "5px 5px 0 0",
            padding: "0px 15px",
          }}
        >
          <div
            className="d-flex align-items-center"
            style={{ justifyContent: "space-between" }}
          >
            <div className="d-flex">{renderTabs()}</div>
           
          </div>
        </div>
      </div>

      <div className="col-md-12">
        <div style={{ border: "1px solid #bfcbe1", backgroundColor: "#fff" }}>
          {activeTabRender()}
        </div>
      </div>
    </>
  );
};

export default PerformanceEvaluationList;




